import { useEffect } from "react";
import { DealBuilderSavedFormat } from "./useDatabaseAPI.ts";
import usePricingManagementStore, { TeamData } from "../../stores/pricing-management.store.ts";

export default function useTeams() {
  const { savedDeals, setSelectedTeam, selectedTeam } = usePricingManagementStore();
  const teams = getAllTeams();

  useEffect(() => {
    if (teams.length <= 0) {
      setSelectedTeam(undefined);
    }
  }, [savedDeals]);

  function getAllTeams(): TeamData[] {
    const teams: Map<String, TeamData> = new Map();

    for (const deal of savedDeals) {
      if (deal.team_id && deal.team_name) {
        teams.set(deal.team_id, {
          name: deal.team_name,
          teamId: deal.team_id
        })
      }
    }

    return [ ...teams.values() ];
  }

  function filterDealsByTeam(deals: DealBuilderSavedFormat[]): DealBuilderSavedFormat[] {
    if (teams.length <= 1 || !selectedTeam) return deals;
    return deals.filter(x => x.team_id === selectedTeam.teamId);
  }

  return { getAllTeams, filterDealsByTeam }
}
